import styled from "@emotion/styled";
import { Grid } from "@material-ui/core";

export const TemplateGrid = styled(Grid)`
  margin-bottom: 1rem;

  .MuiGrid-item {
    & div {
      margin-bottom: 0;
    }
  }
`;
